export default __webpack_public_path__ + "5bad6e62e98e4ed5bc87b3b1c19a71a4.svg";